<div class="w-100 float-left">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0" *ngIf="type == 'ADD'">{{'addEmployee'| translate}} </h5>
        <h5 class="medium m-0" *ngIf="type == 'EDIT'">{{'editEmployee'| translate}} </h5>
        <div class="ml-alert">
        </div>
        <div style="flex-grow: 1;">
        </div>
        <button class="btn btn-secondary" (click)="goToBackPage()">
            <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
        </button>
    </div>

    <div class="loader-div" *ngIf="loading">
        <div class="loader-gif"></div>
    </div>

    <form novalidate #userForm="ngForm" *ngIf="!loading">
        <div class="w-100 float-left">
            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 float-left p-0 mb-sm-3">
                <h6 class="medium mb-sm-3"> {{'employeeDetails' | translate}} </h6>
                <div class="w-100 float-left light-bg p-4">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 float-left">
                        <div class="form-group float-left w-100">
                            <label for="empCode">{{'employeeId'| translate}}
                                <span class="text-danger medium">*</span>
                            </label>

                            <input autocomplete="off" type="text" class="form-control" placeholder="Eg: 22456"
                                   [(ngModel)]="employeeData.empCode" name="empCode" id="empCode" #empCode="ngModel"
                                   maxlength="50"
                                   required>

                            <div *ngIf="empCode.invalid && (empCode.dirty || empCode.touched)"
                                 class="info-text alertMsg alert-danger">
                                <div *ngIf="empCode.errors.required">
                                    {{'empCodeRequired'| translate}}
                                </div>
                            </div>

                            <span class="info-text"> {{'empCodeUnique'| translate}} ({{'maxFifty' | translate}}
                {{'character' | translate}}) </span>
                        </div>

                        <div class="form-group float-left w-100">
                            <label for="email">{{'empEmail' | translate}}
                            </label>
                            <input autocomplete="off" type="email" class="form-control"
                                   placeholder="Eg: jack@oracle.com"
                                   pattern="[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\.[a-zA-Z]{2,3}$"
                                   [(ngModel)]="employeeData.email" name="email"
                                   id="email" #email="ngModel" (ngModelChange)="copyToUsername($event)" maxlength="250">
                            <div *ngIf="email.invalid && (email.dirty || email.touched)"
                                 class="info-text alertMsg alert-danger">
                                <div *ngIf="email.errors.pattern">
                                    {{'invalidEmail'| translate}}
                                </div>
                            </div>
                            <span class="info-text"> {{'empEmailUnique' | translate}} ({{'maxTwoFifty' | translate}}) </span>
                        </div>

                        <div class="form-group float-left w-100">
                            <label for="Username">{{'empUserName'| translate}}
                                <span class="text-danger medium">*</span>
                            </label>

                            <input autocomplete="off" type="email" class="form-control" placeholder="Eg: jack"
                                   [(ngModel)]="employeeData.userName" name="Username" id="Username" #Username="ngModel"
                                   maxlength="250"
                                   required>

                            <div *ngIf="Username.invalid && (Username.dirty || Username.touched)"
                                 class="info-text alertMsg alert-danger">
                                <div *ngIf="Username.errors.required">
                                    {{'userNameRequired'| translate}}
                                </div>
                            </div>

                            <span class="info-text"> {{'empUser' | translate }} ({{'maxTwoFifty' | translate}})</span>
                        </div>

                        <div class="form-group float-left w-100">
                            <label for="licenceNumber">{{'licenceNumber'| translate}}
                            </label>

                            <input autocomplete="off" type="licenceNumber" class="form-control" placeholder=" "
                                   [(ngModel)]="employeeData.licenceNumber" name="licenceNumber" id="licenceNumber"
                                   maxlength="250">

                            <span class="info-text"> {{'licenceNumber' | translate }} ({{'maxTwoFifty' | translate}})</span>
                        </div>


                        <div class="form-group float-left w-100">
                            <label for="rl">{{'role'| translate}}
                            </label>
                            <input autocomplete="off" type="role" disabled=true class="form-control" placeholder=" "
                                   [attr.value]="getRoleLabel(employeeData.userRole)" name="rl" id="rl" maxlength="250">
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 float-left">
                        <div class="form-group float-left w-100">
                            <label for="dname">{{'empDisplayName'| translate}}
                                <span class="text-danger medium">*</span>
                            </label>

                            <input autocomplete="off" type="text" class="form-control"
                                   placeholder="{{'displayName' | translate}}"
                                   [(ngModel)]="employeeData.displayName" maxlength="250" name="dName" id="dname"
                                   #dname="ngModel"
                                   required>

                            <div *ngIf="dname.invalid && (dname.dirty || dname.touched)"
                                 class="alertMsg info-text alert-danger">
                                <div *ngIf="dname.errors.required">
                                    {{'displayNameRequired'| translate}}
                                </div>
                            </div>

                            <span class="info-text"> {{'nameAllOver' | translate}} ({{'maxTwoFifty' | translate}})</span>
                        </div>

                        <div class="form-group float-left w-100">
                            <label for="org"> {{'orgUit' | translate}}
                                <span class="text-danger medium">*</span>
                            </label>

                            <input ng2-auto-complete autocomplete="off" [(ngModel)]="organizationModel"
                                   name="organizationModel"
                                   #org="ngModel" [source]="organizationObservableSource.bind(this)"
                                   [value-formatter]="orgNameValueFormatter"
                                   [list-formatter]="autoCompleteListOrgFormatter"
                                   value-property-name="id" display-property-name="displayName"
                                   placeholder="{{'typeAndChooseEmpOrg' | translate}}" class="form-control"
                                   (valueChanged)="orgSelected()"
                                   (input)="orgChange($event)" [accept-user-input]=false blank-option-text="Select"
                                   [no-match-found-text]="warning" required>

                            <div *ngIf="org.invalid && (org.dirty || org.touched)"
                                 class="info-text alertMsg alert-danger">
                                <div *ngIf="org.errors.required">
                                    {{'selectOrgUnit'| translate}}
                                </div>
                            </div>

                            <span class="info-text"> {{'selectOrgUnit' | translate}}</span>
                        </div>

                        <div class="form-group float-left w-100">
                            <label>{{'dOfHire' | translate}} <span class="text-danger medium">*</span></label>

                            <div class="w-100 float-left relative">
                                <input class="form-control" [ngStyle]="{'background-color':'white'}"
                                       placeholder="YYYY-MM-DD"
                                       name="JoinDate" [(ngModel)]="joiningDate" ngbDatepicker
                                       (ngModelChange)="onDateChange($event)"
                                       #d="ngbDatepicker" readonly [maxDate]="maxDate" [minDate]="minDate" required>
                                <button class="iga-right" (click)="d.toggle(); openDatePicker(d)" type="button">
                                    <i class="fa fa-calendar"></i>
                                </button>
                            </div>

                            <span class="info-text"> {{'dOfHire' | translate }}</span>
                        </div>

                        <div class="form-group float-left w-100">
                            <label>{{'dateOfBirth' | translate}}</label>
                            <div class="w-100 float-left relative">
                                <input class="form-control" [ngStyle]="{'background-color':'white'}"
                                       placeholder="YYYY-MM-DD"
                                       name="dateOfBirth" [(ngModel)]="dateOfBirth" ngbDatepicker
                                       (ngModelChange)="onDateofBirthChange($event)" #dob="ngbDatepicker" readonly
                                       [maxDate]="maxDate"
                                       [minDate]="minDate">
                                <button class="iga-right" (click)="dob.toggle(); openDatePicker(d)" type="button">
                                    <i class="fa fa-calendar"></i>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-left mb-sm-3 text-center">
                <h6 class="medium mb-sm-3"></h6>
                <div class="w-75 relative auto-m">
                    <ng-container *ngIf="!isUpdateImage">
                        <div *ngIf="employeeData.imageUrl">
                            <img [src]="employeeData.imageUrl" class="w-100 rounded-circle">
                            <div class="w-100 float-left mt-4 text-center">
                                <button class="btn btn-danger m-1" (click)="removeImage()">
                                    <i class="fa fa-close mr-1 text-white"></i> {{'remove'| translate}}
                                </button>
                                <button class="btn btn-success m-1 relative" (change)="cropImage($event)">
                                    <input name="myFile" type="file" class="upload-pic" accept=".jpg,.png,.svg,.svgz">
                                    {{'add' | translate}}
                                    <i class="fa fa-plus ml-1 text-white"></i>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="!employeeData.imageUrl">
                            <div *ngIf="!data.image">
                                <img src="./assets/img/profilePic.png" class="w-100 rounded-circle">
                                <input name="myFile" type="file" class="upload-pic" (change)="cropImage($event)"
                                       onclick="value = null"
                                       accept=".jpg,.png,.svg,.svgz">
                                <div class="profile-text">
                  <span> {{'changeYour' | translate}}
                    <br/> {{'profilePic' | translate}} </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isUpdateImage">
                        <div *ngIf="data.image">
                            <img [src]="data.image" class="w-100 rounded-circle">
                            <div class="w-100 float-left mt-4 text-center">
                                <button class="btn btn-danger m-1" (click)="removeImage()">
                                    <i class="fa fa-close mr-1 text-white"></i> {{'remove'| translate}}
                                </button>
                                <button class="btn btn-success m-1 relative" (change)="cropImage($event)">
                                    <input name="myFile" type="file" class="upload-pic" accept="image/*"> {{'add' |
                                    translate}}
                                    <i class="fa fa-plus ml-1 text-white"></i>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- DEPARTMENT DETAILS -->
        <div class="w-100 float-left">
            <h6 class="medium mb-sm-3"> {{'dptDetails' | translate}} </h6>
            <div class="w-100 float-left light-bg p-4">
                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 float-left">
                    <div class="form-group float-left w-100">
                        <label for="categoryModel">{{'jobCat' | translate}}</label>
                        <input ng2-auto-complete autocomplete="off" [(ngModel)]="categoryModel" name="categoryModel"
                               id="categoryModel" [source]="categoryObservableSource.bind(this)"
                               [list-formatter]="autoCompleteListFormatterType" value-property-name="id"
                               display-property-name="displayName" placeholder="{{'typeChooseJob' | translate}}"
                               class="form-control"
                               (valueChanged)="empTypeSelected()" (input)="empTypeChange($event)"
                               [value-formatter]="typeValueFormatter"
                               [accept-user-input]=false blank-option-text="None">
                        <span class="info-text"> {{'selectJobCat' | translate}} </span>
                    </div>

                    <div class="form-group float-left w-100">
                        <label for="managementModel">{{'empType' | translate}}</label>
                        <input ng2-auto-complete autocomplete="off" [(ngModel)]="managementModel" name="managementModel"
                               id="managementModel" [source]="managementLevelObservableSource.bind(this)"
                               [list-formatter]="autoCompleteListNameFormatter" value-property-name="id"
                               display-property-name="displayName" placeholder="{{'typeChooseEmp' | translate}}"
                               class="form-control"
                               (valueChanged)="categoryTypeSelected()" (input)="categoryTypeChange($event)"
                               [value-formatter]="nameValueFormatter" [accept-user-input]=false
                               blank-option-text="Select"
                               [no-match-found-text]="warning">
                        <span class="info-text"> {{'empBelongs' | translate}}</span>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 float-left">
                    <div class="form-group float-left w-100">
                        <label for="designationModel">{{'employeeDesignation' | translate}}</label>
                        <input ng2-auto-complete autocomplete="off" [(ngModel)]="designationModel"
                               name="designationModel"
                               id="designationModel" [source]="designationObservableSource.bind(this)"
                               [list-formatter]="autoCompleteListNameFormatter" value-property-name="id"
                               display-property-name="displayName" placeholder="{{'typeChooseDesignation' | translate}}"
                               class="form-control" (valueChanged)="designationSelected()"
                               (input)="designationChange($event)"
                               max-num-list=5 [value-formatter]="nameValueFormatter" blank-option-text="Select"
                               [accept-user-input]=false
                               [no-match-found-text]="warning">
                        <span class="info-text"> {{'selectDesignation' | translate}} </span>
                    </div>

                    <div class="form-group float-left w-100">
                        <label for="gradeModel"> {{'selectGrade' | translate}}</label>
                        <input ng2-auto-complete autocomplete="off" [(ngModel)]="gradeModel" name="gradeModel"
                               id="gradeModel"
                               [source]="gradeObservableSource.bind(this)"
                               [list-formatter]="autoCompleteListNameFormatter"
                               value-property-name="id" display-property-name="displayName"
                               placeholder="{{'typeChooseGrade' | translate}}" class="form-control"
                               (valueChanged)="gradeSelected()"
                               (input)="gradeChange($event)" [value-formatter]="nameValueFormatter"
                               [accept-user-input]=false
                               blank-option-text="Select" [no-match-found-text]="warning">
                        <span class="info-text"> {{'selectEmpJobGrade' | translate}} </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- MANAGEMENT DETAILS -->
        <div class="w-100 float-left mt-3 mb-3">
            <h6 class="medium mb-sm-3"> {{'managementDetails' | translate}} </h6>
            <div class="w-100 float-left light-bg p-4">
                <div class="col-lg-6 col-md-6 form-group float-left">
                    <label for="sup">{{'supervisor' | translate}}</label>
                    <div class="col-lg-11 col-md-11 col-sm-11 col-xs-11 float-left p-0">
                        <input ng2-auto-complete autocomplete="off" [(ngModel)]="primarySupervisorModel"
                               name="primarySupervisorModel" [source]="primarySupervisorObservableSource.bind(this)"
                               [list-formatter]="autoCompleteListFormatter" value-property-name="id"
                               display-property-name="displayName"
                               placeholder="{{'typeChooseSupervisor' | translate}}" class="form-control"
                               (valueChanged)="supSelected()"
                               (input)="supChange($event)" [accept-user-input]=false blank-option-text="Select"
                               [no-match-found-text]="warning" id="sup" max-num-list=5>
                        <span class="info-text"> {{'empSupervisor' | translate}}</span>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left p-2" title="Add secondary supervisor(s)">
                        <i class="fa fa-plus text-20x" (click)="addSecondarySupervisor()"></i>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 form-group float-left">
                    <label for="verifier"> {{'verifier' | translate}}</label>
                    <input ng2-auto-complete autocomplete="off" [(ngModel)]="verifierModel" name="verifierModel"
                           [source]="primaryVerifierObservableSource.bind(this)"
                           [list-formatter]="autoCompleteListFormatter"
                           value-property-name="id" display-property-name="displayName"
                           placeholder="{{'typeChooseVerifier' | translate}}" class="form-control"
                           (valueChanged)="verifierSelected()"
                           (input)="verifierChange($event)" id="verifier" max-num-list=5 [accept-user-input]=false
                           blank-option-text="Select" [no-match-found-text]="warning">
                    <span class="info-text"> {{'empVerifier' | translate }} </span>
                </div>

                <ng-container *ngIf="employeeData.secSupervisorIds && employeeData.secSupervisorIds.length > 0">
                    <div class="col-lg-6 col-md-6 form-group float-left"
                         *ngFor="let sup of employeeData.secSupervisorIds;index as i">
                        <label for="sup">{{'secondarySupervisor' | translate }}</label>
                        <div class="col-lg-11 col-md-11 col-sm-11 col-xs-11 float-left p-0">
                            <input ng2-auto-complete autocomplete="off" [(ngModel)]="secondarySupervisorModel[i]"
                                   name="secondarySupervisorModel{{i}}"
                                   [source]="secondarySupervisorObservableSource.bind(this)"
                                   [list-formatter]="autoCompleteListFormatter" value-property-name="id"
                                   display-property-name="displayName"
                                   placeholder="{{'typeChooseSupervisor' | translate}}"
                                   class="form-control" (valueChanged)="secSupSelected(i)"
                                   (input)="secSupChange($event)"
                                   [accept-user-input]=false blank-option-text="Select" [no-match-found-text]="warning"
                                   id="sup"
                                   max-num-list=5>
                            <span class="info-text"> </span>
                        </div>
                        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left p-2"
                             title="Add secondary supervisor">
                            <i class="fa fa-close text-20x"
                               (click)="deleteSecondarySupervisor(secondarySupervisorModel, i)"></i>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>

        <button *ngIf="(type == 'EDIT') && !showButtonLoading" class="btn btn-primary float-right mb-4 ml-4"
                type="submit"
                [disabled]="userForm.invalid || disableSave" (click)="saveEmployeeData()">
            {{'updateEmp' | translate}}
        </button>
        <button *ngIf="type == 'ADD' && !showButtonLoading" class="btn btn-primary float-right mb-4 ml-4" type="submit"
                [disabled]="userForm.invalid || disableSave" (click)="saveEmployeeData()">
            {{'saveEmp' | translate}}
            <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i>
        </button>
        <button *ngIf="type == 'ACTIVATE' && !showButtonLoading" class="btn btn-primary float-right mb-4 ml-4"
                type="submit"
                [disabled]="userForm.invalid || disableSave" (click)="saveEmployeeData()">
            {{'activateEmployee' | translate}}
        </button>
        <button *ngIf="type == 'EDIT' && showButtonLoading" [disabled]="showButtonLoading"
                class="btn btn-primary float-right mb-4 ml-4">
            {{'updating' | translate}}
            <i class="fa fa-spinner fa-spin text-white m-l-smd"></i>
        </button>
        <button *ngIf="type == 'ADD' && showButtonLoading" [disabled]="showButtonLoading"
                class="btn btn-primary float-right mb-4 ml-4">
            {{'saving' | translate}}
            <i class="fa fa-spinner fa-spin text-white m-l-smd"></i>
        </button>
        <button *ngIf="type == 'ACTIVATE' && showButtonLoading" [disabled]="showButtonLoading"
                class="btn btn-primary float-right mb-4 ml-4">
            {{'activating' | translate}}
            <i class="fa fa-spinner fa-spin text-white m-l-smd"></i>
        </button>
    </form>

    <button class="btn btn-secondary float-right mb-4" (click)="goToBackPage()"> {{'cancel' | translate}}</button>
</div>


// WEBPACK FOOTER //
// ./src/app/employee/addEmployees.html